import messages from "../../locale/messages";
import { containsMalicious } from "../../helpers/textRestriction";

const validate = (values) => {
  const errors = {};

  // === Main Fields Validation ===
  if (!values.houseType) {
    errors.houseType = messages.required;
  }

  if (!values.country || values.country.toString().trim() === "") {
    errors.country = messages.required;
  }

  if (!values.state || values.state.toString().trim() === "") {
    errors.state = messages.required;
  } else if (containsMalicious(values.state)) {
    errors.state = messages.invalidInput;
  }

  if (!values.city || values.city.toString().trim() === "") {
    errors.city = messages.required;
  } else if (containsMalicious(values.city)) {
    errors.city = messages.invalidInput;
  }

  if (!values.street || values.street.toString().trim() === "") {
    errors.street = messages.required;
  }

  if (!values.zipcode || values.zipcode.toString().trim() === "") {
    errors.zipcode = messages.required;
  }

  // === FAQ Section Validation ===
  const faqs = values?.faqs || [];
  if (Array.isArray(faqs)) {
    const faqsErrors = [];

    faqs.forEach((faq, index) => {
      const title = faq?.title?.trim();
      const content = faq?.content?.trim();
      const faqError = {};

      // Required validation
      if (title && !content) {
        faqError.content = messages.required;
      } else if (!title && content) {
        faqError.title = messages.required;
      }

      // Malicious check
      if (title && containsMalicious(title)) {
        faqError.title = messages.invalidInput;
      }

      if (content && containsMalicious(content)) {
        faqError.content = messages.invalidInput;
      }

      if (Object.keys(faqError).length > 0) {
        faqsErrors[index] = faqError;
      }
    });

    if (faqsErrors.length && faqsErrors.some(Boolean)) {
      errors.faqs = faqsErrors;
    }
  }

  return errors;
};

export default validate;
